export class AzureCredentialsConfig {
    public entraUPN : string;
    public azureVirtualDesktopLink : string;
}